<template>
  <v-container class="white-wrapper" fluid>
    <div class="last-item-one content-wrapper">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="text-center font-60 font-weight-bold mb-5">
            휴대전화 인증
          </div>

          <v-select
            color="#121212"
            :items="ctryCodes"
            v-model="inputCtryCode"
            required
            solo
            hide-details
            class="mb-1"
            @change="onChangeCtryCode"
            :readonly="isMatch"
          >
            <template slot="selection" slot-scope="{ item }">
              <div class="d-flex select-item">
                {{ `${item.country} (+${item.code})` }}
              </div>
            </template>
            <template slot="item" slot-scope="{ item }">
              <div class="d-flex select-item" style="color:#121212 !important;">
                {{ `${item.country} (+${item.code})` }}
              </div>
            </template>
          </v-select>
          <validation-provider ref="phone" v-slot="{ errors }" name="phone">
            <v-text-field
              type="number"
              placeholder="전화번호를 입력하세요."
              v-model="inputPhone"
              class="mb-1 phone-wrapper"
              hide-details
              solo
              @change="onChangePhone"
              @keypress="onKeydown"
              :readonly="isMatch"
            >
              <template slot="append">
                <v-btn
                  class="px-2 rounded-r"
                  height="48px"
                  color="primary"
                  depressed
                  tile
                  @click="sendAuthSms"
                  :disabled="!isValidPhone || isMatch || sendSms"
                  >인증번호 받기</v-btn
                >
              </template>
            </v-text-field>
            <validation-provider
              v-slot="{ errors: verifyErrors }"
              name="verifyCode"
            >
              <v-text-field
                type="number"
                placeholder="인증번호를 입력하세요."
                v-model="verifyCode"
                class="verify-code-wrapper"
                hide-details
                solo
                @change="onChangeVerifyCode"
                :disabled="!sendSms"
                :readonly="isMatch"
              >
                <!-- <template slot="append">
                  <span v-if="!isMatch">{{ minutes + ':' + seconds }}</span>
                </template> -->
              </v-text-field>
              <div style="min-height:14px;margin-bottom:8px;padding: 0 12px;">
                <v-expand-transition>
                  <div
                    v-if="isMatch || sendSms"
                    class="d-flex flex-column text-caption success--text"
                    v-html="scsmsg"
                  ></div>
                </v-expand-transition>
                <v-expand-transition>
                  <div
                    v-if="errors[0] || verifyErrors[0] || errmsg"
                    class="d-flex flex-column text-caption error--text"
                    v-html="errors[0] || verifyErrors[0] || errmsg"
                  ></div>
                </v-expand-transition>
              </div>
            </validation-provider>
          </validation-provider>

          <v-divider class="mb-5 mt-3"></v-divider>
          <div class="text-center text-caption">
            휴대전화 인증 회원 전환을 위해 SMS 인증을 진행하시기 바랍니다.<br />
            '페이캄 월렛'은 1인 1계정이 원칙이며,<br />
            전화번호 1개당 1개의 계정만 인증할 수 있습니다.<br />
            <!-- <v-btn small text color="primary" @click="toSignin"
              >로그인 페이지로</v-btn
            > -->
          </div>

          <v-btn
            class="bottom-btn"
            width="50%"
            tile
            x-large
            height="56px"
            @click="onClickLater"
          >
            다음에 하기
          </v-btn>
          <v-btn
            class="bottom-btn"
            color="primary"
            width="50%"
            tile
            x-large
            height="56px"
            type="submit"
            style="left:50%;"
          >
            인증 완료
          </v-btn>
        </form>
      </validation-observer>
    </div>
  </v-container>
</template>

<script>
import { required, regex } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'
import countryCode from '@/configs/countryCode'
setInteractionMode('eager')

export default {
  data() {
    return {
      ctryCode: { country: 'South Korea', code: 82 },
      inputCtryCode: { country: 'South Korea', code: 82 },
      ctryCodes: [],
      inputPhone: null,
      phone: null,
      verifyCode: null,
      sendSms: false,
      totalTime: 3 * 60,
      timer: null,
      isMatch: false,
      errmsg: '',
      isValidPhone: false,
      scsmsg: ''
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    loading() {
      return this.$store.getters.loading
    },
    minutes() {
      const minutes = Math.floor(this.totalTime / 60)
      return this.padTime(minutes)
    },
    seconds() {
      const seconds = this.totalTime - this.minutes * 60
      return this.padTime(seconds)
    }
  },
  created() {
    // if (!this.user || this.user.auth_sms === 'Y') this.$router.push('/home')
    extend('required', {
      ...required,
      message: '인증이 필요합니다.'
    })
    extend('regex', {
      ...regex,
      message: '유효하지 않은 전화번호입니다.'
    })

    this.ctryCodes = countryCode
  },
  // watch: {
  //   totalTime(val) {
  //     if (val === 0 && !this.isMatch) {
  //       this.verifyCode = null
  //       this.$refs.phone.errors = ['인증시간이 초과되었습니다.']
  //       this.resetTimer()
  //       this.sendSms = false
  //     }
  //   }
  // },
  methods: {
    onClickLater() {
      this.eventDialog = false
      let expiredays = 1
      // console.log(document.cookie)
      let today = new Date()
      today = new Date(
        parseInt(today.getTime() / 86400000) * 86400000 + 54000000
      )
      if (today > new Date()) {
        expiredays = expiredays - 1
      }
      today.setDate(today.getDate() + expiredays)
      this.$cookies.set('asp', escape(true), today.toGMTString())
      this.$router.push('/home')
    },
    toSignin() {
      this.$store.dispatch('LOGOUT').then(() => this.$router.push('/signin'))
    },
    validPhone(phone) {
      const regx = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/

      if (this.inputCtryCode.code === 82 && !regx.test(phone)) {
        this.isValidPhone = false
        this.errmsg = this.$t('sms.m01')
        return
      }
      if (
        this.inputCtryCode.code !== 82 &&
        (phone.length < 8 || phone.length > 15)
      ) {
        this.isValidPhone = false
        this.errmsg = this.$t('sms.m01')
        return
      }
      this.errmsg = ''

      this.isValidPhone = true
    },
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()
      if (this.inputCtryCode.code === 82 && e.target.value.length > 10)
        e.preventDefault()
      if (e.target.value.length > 14) e.preventDefault()
      this.validPhone(e.target.value)
    },
    startTimer() {
      this.timer = setInterval(() => this.countdown(), 1000)
    },
    stopTimer() {
      clearInterval(this.timer)
      this.timer = null
    },
    resetTimer() {
      this.totalTime = 3 * 60
      clearInterval(this.timer)
      this.timer = null
    },
    padTime(time) {
      return (time < 10 ? '0' : '') + time
    },
    countdown() {
      if (this.totalTime >= 1) {
        this.totalTime--
      } else {
        this.totalTime = 0
        this.resetTimer
      }
    },
    sendAuthSms() {
      if (!this.inputPhone) {
        this.$refs.phone.errors = [this.$t('sms.phonePlaceholder')]
        return
      }
      this.$store.commit('loading', true)
      this.$refs.phone.errors = []
      // this.resetTimer()
      this.ctryCode = this.inputCtryCode
      this.phone = this.inputPhone
      const params = {
        email: this.user.email,
        phone: this.phone,
        country: this.ctryCode.code
      }
      // console.log(params, this.sendSms)

      this.$store
        .dispatch('auth_sms', params)
        .then((res) => {
          this.$store.commit('loading', false)
          if (res.data && res.data.result) {
            this.sendSms = true
            // console.log(res, this.sendSms)
            // this.startTimer()
            this.$refs.phone.errors = []
            this.scsmsg = `<span>${this.$t('sms.m02')}</span><span>${this.$t(
              'sms.m03'
            )}</span>`
            this.errmsg = `<span>${this.$t('sms.m04')}</span>`
          } else if (res.data && res.data.code === 'invalid_sms') {
            this.$refs.phone.errors = []
            this.sendSms = true
            this.scsmsg = `<span>${this.$t('sms.m05')}</span>
            <span>${this.$t('sms.m03')}</span>`
            this.errmsg = `<span>${this.$t('sms.m04')}</span>`
          } else throw res
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          // console.log(err)
          this.$refs.phone.errors = []
          this.errmsg = ''
          if (err.data && err.data.code === 'duplicate') {
            this.$refs.phone.errors = [this.$t('sms.m06')]
          } else if (err.data && err.data.code === 'limit_day') {
            this.errmsg = `<span>${this.$t('sms.m07')}</span>
            <span>${this.$t('sms.m08')}</span>`
          } else if (err.data && err.data.code === 'auth_mail') {
            this.errmsg = `<span>${this.$t('sms.m09')}</span>`
          } else if (err.data && err.data.code === 'phone_type') {
            this.errmsg = `<span>${this.$t('sms.m01')}</span>`
          } else if (err.data && err.data.code === 'fail_sms') {
            this.errmsg = `<span>${this.$t('sms.m15')}</span><span>${this.$t(
              'sms.m16'
            )}</span>`
          } else {
            this.$refs.phone.errors = [this.$t('sms.m10')]
          }
        })
    },
    onChangeCtryCode() {
      if (this.inputPhone) {
        this.validPhone(this.inputPhone)
      }
      if (this.inputCtryCode !== this.crtyCode) {
        // this.resetTimer()
        this.$refs.phone.errors = [this.$t('sms.m11')]
        this.sendSms = false
        this.verifyCode = null
        this.isMatch = false
      }
    },
    onChangePhone() {
      this.validPhone(this.inputPhone)
      if (this.inputPhone !== this.phone) {
        // this.resetTimer()
        this.$refs.phone.errors = [this.$t('sms.m11')]
        this.sendSms = false
        this.verifyCode = null
        this.isMatch = false
      }
    },
    onChangeVerifyCode() {
      // if (!this.timer) {
      //   this.verifyCode = null
      // }
      this.$store.commit('loading', true)
      // console.log(this.sendSms, this.verifyCode)
      if (this.sendSms && this.verifyCode) {
        const params = {
          email: this.user.email,
          phone: this.phone,
          country: this.ctryCode.code,
          auth_input: this.verifyCode
        }
        // console.log(params)
        this.$store
          .dispatch('auth_sms_confirm', params)
          .then((res) => {
            this.$store.commit('loading', false)
            this.$refs.phone.errors = []
            this.errmsg = ''
            // console.log(res)
            if (res.data && res.data.result) {
              this.isMatch = true
              this.scsmsg = `<span>${this.$t('sms.m12')}</span>`
            } else {
              this.isMatch = false

              if (res.data && res.data.code === 'not_match')
                this.$refs.phone.errors = [this.$t('sms.m13')]
              else if (res.data && res.data.code === 'different')
                this.$refs.phone.errors = [this.$t('sms.m14')]
              else throw res
            }
          })
          .catch((err) => {
            console.log(err)
            this.$store.commit('loading', false)
            this.isMatch = false
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: this.$t('errorServer'),
              timeout: 2000
            })
          })
      } else {
        this.errmsg = ''
        this.$store.commit('loading', false)
        this.$refs.phone.errors = [this.$t('sms.m11')]
      }
    },
    onSubmit() {
      this.$refs.observer.validate().then((res) => {
        if (!this.isMatch) {
          this.$refs.phone.errors = [this.$t('sms.m11')]
          return
        }
        if (res) {
          const params = {
            email: this.user.email,
            phone: this.phone,
            country: this.ctryCode.code
          }
          this.$store.dispatch('auth_sms_complete', params).then((res) => {
            if (res.data && res.data.result) {
              // console.log(res)

              this.$store
                .dispatch('FETCH_USERINFO')
                .then((response) => {
                  this.$store.commit('loading', false)
                  this.$router.push('/home')
                })
                .catch((error) => {
                  // console.log(error)
                  this.$store.commit('loading', false)
                  this.$store.dispatch('toast', {
                    toast: true,
                    toast_msg: this.$t('errorServer'),
                    timeout: 3000
                  })
                })
            } else if (res.data.code === 'phone') {
              this.verifyCode = null
              this.isMatch = false
              this.sendSms = false
              // this.resetTimer()
              this.$refs.phone.errors = [this.$t('sms.m06')]
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.bottom-btn {
  bottom: 0;
}
.white-wrapper {
  display: flex;
  align-items: center;
}
.content-wrapper {
  padding: 1.3rem;
  margin: 0 auto;
}
.phone-wrapper >>> .v-input__append-inner {
  margin: 0 !important;
}
.phone-wrapper >>> .v-input__slot {
  padding-right: 0 !important;
}
</style>
